module.exports = __webpack_public_path__ + "static/media/arrow-right-long.1e393bcb.svg";